import { __ } from "@wordpress/i18n";
import { LocaleObject } from "yup";

/**
 * Localized validation error messages for Yup schema validation
 *
 * This object defines Portuguese error messages for all Yup validation types
 * Organized by data type and validation rule
 * Each message uses WordPress i18n for translation support
 *
 * @see {@link https://github.com/jquense/yup#using-a-custom-locale-dictionary} Yup documentation
 */
export const validationsLocale: LocaleObject = {
  // General validation messages that apply to all types
  mixed: {
    default: __("Campo inválido", "df-simulators"),
    required: __("Este campo é obrigatório", "df-simulators"),
    oneOf: __(
      "Deve ser um dos seguintes valores: ${values}",
      "df-simulators",
    ) as unknown as string,
    notOneOf: __(
      "Não pode ser um dos seguintes valores: ${values}",
      "df-simulators",
    ) as unknown as string,
    notType: __("Tipo de valor inválido", "df-simulators") as unknown as string,
  },

  // String type validation messages
  string: {
    length: __(
      "Deve ter exatamente ${length} caracteres",
      "df-simulators",
    ) as unknown as string,
    min: __(
      "Deve ter pelo menos ${min} caracteres",
      "df-simulators",
    ) as unknown as string,
    max: __(
      "Deve ter no máximo ${max} caracteres",
      "df-simulators",
    ) as unknown as string,
    matches: __(
      "Deve corresponder ao padrão: ${regex}",
      "df-simulators",
    ) as unknown as string,
    email: __("Formato de e-mail inválido", "df-simulators"),
    url: __("URL inválida", "df-simulators"),
    trim: __("Não deve conter espaços no início ou no fim", "df-simulators"),
    lowercase: __("Deve estar em minúsculas", "df-simulators"),
    uppercase: __("Deve estar em maiúsculas", "df-simulators"),
  },

  // Number type validation messages
  number: {
    min: __("Deve ser no mínimo ${min}", "df-simulators") as unknown as string,
    max: __("Deve ser no máximo ${max}", "df-simulators") as unknown as string,
    lessThan: __(
      "Deve ser menor que ${less}",
      "df-simulators",
    ) as unknown as string,
    moreThan: __(
      "Deve ser maior que ${more}",
      "df-simulators",
    ) as unknown as string,
    positive: __("Deve ser um número positivo", "df-simulators"),
    negative: __("Deve ser um número negativo", "df-simulators"),
    integer: __("Deve ser um número inteiro", "df-simulators"),
  },

  // Date type validation messages
  date: {
    min: __(
      "A data deve ser posterior a ${min}",
      "df-simulators",
    ) as unknown as string,
    max: __(
      "A data deve ser anterior a ${max}",
      "df-simulators",
    ) as unknown as string,
  },

  // Boolean type validation messages
  boolean: {
    isValue: __(
      "Este campo deve ser ${value}",
      "df-simulators",
    ) as unknown as string,
  },

  // Object type validation messages
  object: {
    noUnknown: __(
      "Não são permitidos campos desconhecidos",
      "df-simulators",
    ) as unknown as string,
  },

  // Array type validation messages
  array: {
    min: __(
      "Deve ter pelo menos ${min} itens",
      "df-simulators",
    ) as unknown as string,
    max: __(
      "Deve ter no máximo ${max} itens",
      "df-simulators",
    ) as unknown as string,
    length: __(
      "Deve ter exatamente ${length} itens",
      "df-simulators",
    ) as unknown as string,
  },
};
